import { request } from '@/api/client'
import { API_ENDPOINTS as apiEndpoints } from '@/api/endpoints'

export interface TokenStatsParams {
  start_date?: string
  end_date?: string
}

export interface UserRankingItem {
  user_id: number
  username: string
  total_requests: number
  total_tokens: number
  total_cost: number
}

export interface UsageDetailItem {
  id: number
  user_id: number
  request_id: string
  model: string
  provider: string
  prompt_tokens: number
  completion_tokens: number
  total_tokens: number
  prompt_cost: number
  completion_cost: number
  total_cost: number
  cost_amount: number
  cost_currency: string
  purpose: string | null
  session_id: string | null
  created_at: string
}

export interface UsageDetailsParams {
  page?: number
  page_size?: number
  start_date?: string
  end_date?: string
  provider?: string
  model?: string
  user_id?: number
}

export const tokenUsageApi = {
  // 获取当前用户的Token统计
  getUserStats(params?: TokenStatsParams) {
    return request.get(apiEndpoints.tokenUsage.userStats, { params })
  },

  // 获取全局Token统计（管理员）
  getGlobalStats(params?: TokenStatsParams) {
    return request.get(apiEndpoints.tokenUsage.globalStats, { params })
  },

  // 获取供应商统计（管理员）
  getProviderStats(params?: TokenStatsParams & { provider?: string }) {
    return request.get(apiEndpoints.tokenUsage.providerStats, { params })
  },

  // 获取每日使用趋势
  getDailyTrend(days: number = 7) {
    return request.get(apiEndpoints.tokenUsage.dailyTrend, { params: { days } })
  },

  // 获取模型使用排行榜（管理员）
  getModelRanking(params?: { top?: number } & TokenStatsParams) {
    return request.get(apiEndpoints.tokenUsage.modelRanking, { params })
  },

  // 获取用户排行榜（管理员）
  getUserRanking(params?: { top?: number } & TokenStatsParams) {
    return request.get(apiEndpoints.tokenUsage.userRanking, { params })
  },

  // 获取指定用户的统计（管理员）
  getSpecificUserStats(userId: number, params?: TokenStatsParams) {
    return request.get(`${apiEndpoints.tokenUsage.userStats}/${userId}/stats`, { params })
  },

  // 获取Token使用明细（管理员）
  getUsageDetails(params?: UsageDetailsParams) {
    return request.get(apiEndpoints.tokenUsage.usageDetails, { params })
  }
}